import { useCallback, useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import { LockKeyhole, ShieldCheck } from "lucide-react";
import { useParams } from "react-router-dom";
import type { Post } from "../../shared/contracts";
import { CommentsSection } from "../components/CommentsSection";
import { PostCard } from "../components/PostCard";
import { StatePanel } from "../components/StatePanel";
import { useApp } from "../context/AppContext";
import { api } from "../lib/api";

export function SharedPostPage() {
  const { shareToken = "" } = useParams();
  const { config } = useApp();
  const [post, setPost] = useState<Post | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const load = useCallback(async () => {
    setLoading(true); setError(null);
    try { setPost((await api<{ post: Post }>(`/posts/share/${shareToken}`)).post); }
    catch (loadError) { setError(loadError instanceof Error ? loadError.message : "分享内容加载失败"); }
    finally { setLoading(false); }
  }, [shareToken]);
  useEffect(() => { void load(); }, [load]);

  return <main className="shared-page"><header className="shared-page-brand"><ShieldCheck /><span><strong>{config?.site.name ?? "共享朋友圈"}</strong><small>安全分享视图</small></span></header><div className="shared-page-content">
    {loading ? <StatePanel kind="loading" title="正在打开分享内容" /> : null}
    {!loading && (error || !post) ? <StatePanel kind="error" title="分享内容无法打开" description={error ?? "链接可能已失效"} onRetry={() => void load()} /> : null}
    {post ? <><Alert severity="info" icon={<LockKeyhole />}>此页面只展示分享者指定的这一条动态，不提供广场、其他作者内容或站内导航入口。</Alert><PostCard initialPost={post} detail isolated /><CommentsSection postId={post.id} shareToken={shareToken} readOnly /></> : null}
  </div><footer className="shared-page-footer">分享内容仅供浏览，交易请通过平台配置的商城完成。</footer></main>;
}
